import type {FC} from 'react';
import type {GetMyCalendarType} from '../../../../core/entities/calendar/schema';
import {CalendarScheduleItem} from './CalendarScheduleItem';

type Props = {
  calendarData: GetMyCalendarType;
};

export const CalendarScheduleList: FC<Props> = ({calendarData}) => {
  return (
    <ul className="w-full">
      {calendarData.Schedules.map((calendarSchedule, index) => (
        <CalendarScheduleItem
          key={calendarSchedule.eventID}
          calendarSchedule={calendarSchedule}
          isFirst={index === 0}
        />
      ))}
    </ul>
  );
};
